<template>
  <page-outline :title="$t('suppliers.form_supplier_create_title')"
    icon="icon-sent">
    <template slot="pageContent">
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="siren" isMandatory
            :idLabel="$t('suppliers.supplier_id')"
            :mandatoryErrorIndicator="sirenError"
            :regexpErrorIndicator="sirenRegexpError"
            :warningIndicator="controlsConfig === '1' ? administrativeState === 'F' : false"
            :specificErrorIndicator="controlsConfig === '2' ? administrativeState === 'F' : false"
            :maxLength="9"
            :specificMessage="$t('suppliers.closed_admin_state')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="!LMSGsupplierconfig">
          <form-write-group-label-input v-model="socialReason" isMandatory
            :idLabel="$t('common.social_reason')"
            :mandatoryErrorIndicator="socialReasonError"
            :warningIndicator="controlsConfig === '1' ? differentSocialReason : false"
            :specificErrorIndicator="controlsConfig === '2' ? differentSocialReason : false"
            :specificMessage="$t('suppliers.not_same_social_reason', {realSocialReason : databaseSocialReason})">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-else>
          <form-write-group-label-input v-model="sellerIdentifier" isMandatory
            :idLabel="$t('filter.supplier_id')"
            :mandatoryErrorIndicator="sellerIdentifierError">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="siret" isMandatory
            :idLabel="$t('suppliers.supplier_siret')"
            :mandatoryErrorIndicator="siretError"
            :regexpErrorIndicator="siretRegexpError"
            :warningIndicator="controlsConfig === '1' ? differentSIRET : false"
            :specificErrorIndicator="controlsConfig === '2' ? differentSIRET : false"
            :maxLength="14"
            :specificMessage="$t('suppliers.not_same_siret', {realSIRET : databaseSIRET})">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="dateCreation"
            :idLabel="$t('common.dt_crtn')">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group" v-if="LMSGsupplierconfig">
          <form-write-group-label-input v-model="socialReason" isMandatory
            :idLabel="$t('common.social_reason')"
            :mandatoryErrorIndicator="socialReasonError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="name"
            :idLabel="LMSGsupplierconfig ? $t('suppliers.supplier_name') : $t('suppliers.supplier_name_2')"
            :warningIndicator="controlsConfig === '1' ? differentLastName : false"
            :specificErrorIndicator="controlsConfig === '2' ? differentLastName : false"
            :specificMessage="$t('suppliers.not_same_lastname', {realLastName : databaseLastName})">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="!LMSGsupplierconfig">
          <form-write-group-label-input v-model="firstname"
            :idLabel="$t('suppliers.supplier_firstname')"
            :warningIndicator="controlsConfig === '1' ? differentFirstName : false"
            :specificErrorIndicator="controlsConfig === '2' ? differentFirstName : false"
            :specificMessage="$t('suppliers.not_same_firstname', {realFirstName : databaseFirstName})">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="coreBusiness"
            :idLabel="$t('suppliers.core_business')"
            :warningIndicator="controlsConfig === '1' ? invalidCoreBusiness : false"
            :specificErrorIndicator="controlsConfig === '2' ? invalidCoreBusiness : false"
            :specificMessage="isCoreBusinessAllowed == '1' ?
                              $t('suppliers.not_same_core_business', {realCoreBusinessLabel : databaseCoreBusinessCode + ' - ' + databaseCoreBusinessLabel}) :
                              $t('suppliers.illegal_core_business')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input
            :idLabel="$t('suppliers.legal_status')"
            :inputType="'listeSelect'"
            :warningIndicator="controlsConfig === '1' ? differentLegalStatus : false"
            :specificErrorIndicator="controlsConfig === '2' ? differentLegalStatus : false"
            :specificMessage="$t('suppliers.not_same_legal_status', {realLegalStatus : databaseLegalStatuslabel})">
            <select class="form-control" id="sel2" readonly v-model="legalStatus"
              :class="{errorBorder : differentLegalStatus && controlsConfig === '2', warningBorder: differentLegalStatus && controlsConfig === '1'}">
              <option value="">{{ $t('suppliers.slct_legal_status') }}</option>
              <option v-for="status in legalStatusList" :key="status.code" :value="status.code">
                {{ status.label }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row v-if="LMSGsupplierconfig">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input
            :idLabel="$t('common.eml_adrs')"
            v-model="emailAddress" :regexpErrorIndicator="emailAddressRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group mt-sm-4">
          <b-form-checkbox class="mt-sm-2" v-model="createAccount" :value="1" :unchecked-value="0">
            {{ $t('suppliers.moneyroad_create_account') }}
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input
            :idLabel="$t('common.adrs')"
            v-model="address">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input
            :idLabel="$t('common.zp_code')"
            v-model="zipCode">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input
            :idLabel="$t('common.cty')"
            v-model="townName">
          </form-write-group-label-input>
        </b-col>
      </b-row>

    </template>
    <template slot="footerButtons">
      <b-row class="form-group justify-content-start">
        <b-col md="3" offset-md="8">
          <f7-button class="button-action milkyBlockBlack"
            :disabled="isCoreBusinessAllowed === '0'"
            @click="createSupplier">
            <i class="icon fa fa-save"></i>
            {{ $t('suppliers.form_supplier_create_button') }}
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>
<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import legalStatusList from './data/legalstatus.json'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {reloadPage} from '@/helpers/routing'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag, validateSIREN} from '@/helpers/validator'
/** @author TLV - JPR 06/11/2020
* @brief Component for adding Suppliers
*/
export default {
  name: 'CreateSupplierForm',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      address: '',
      administrativeState: 'A',
      controlsConfig: '0',
      coreBusiness: '',
      coreBusinessCode: '',
      coreBusinessLabel: '',
      createAccount: 0,
      databaseCoreBusinessCode: '',
      databaseCoreBusinessLabel: '',
      databaseFirstName: '',
      databaseLastName: '',
      databaseLegalStatus: '',
      databaseSIRET: '',
      databaseSocialReason: '',
      dateCreation: '',
      emailAddress: '',
      emailAddressRegexpError: false,
      firstname: '',
      isCoreBusinessAllowed: '1',
      legalStatus: '',
      legalStatusList: legalStatusList,
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      name: '',
      sellerIdentifier: '',
      sellerIdentifierError: false,
      siren: '',
      sirenError: false,
      sirenRegexpError: false,
      siret: '',
      siretError: false,
      siretRegexpError: false,
      socialReason: '',
      socialReasonError: false,
      townName: '',
      zipCode: ''
    }
  },
  watch: {
    /** @author TLV 15/02/2021
    * @brief Si le SIREN entré par l'utilisateur est valide, on met à jour le
    *       représentant légal et le statut juridique via un appel à la bdd
    */
    siren () {
      if (validateSIREN(this.siren)) {
        let that = this
        that.$f7.showPreloader(this.$i18n.t('suppliers.automatic_fill'))
        that.$engine.services.suppliers.getLegalStatus(this.siren)
        .then(response => {
          if (response.status === 200) {
            that.sirenRegexpError = false
            let address = ''
            let addressElements = ['StreetNumber', 'StreetNumberRepetition', 'StreetType', 'StreetName']
            for (let indexElement in addressElements) {
              let element = addressElements[indexElement]
              if (response.data[element]) {
                if (address === '') {
                  address += response.data[element]
                } else {
                  address += ' ' + response.data[element]
                }
              }
            }
            if (address === '' && response.data.OtherAddress) {
              address = response.data.OtherAddress
            }
            that.siret = response.data.Siret
            that.legalStatus = that.databaseLegalStatus = response.data.LegalForm ? response.data.LegalForm : ''
            that.name = that.databaseLastName = response.data.LastName ? response.data.LastName : ''
            that.firstname = that.databaseFirstName = response.data.FirstName ? response.data.FirstName : ''
            that.administrativeState = response.data.AdministrativeState ? response.data.AdministrativeState : ''
            that.socialReason = that.databaseSocialReason = response.data.SocialReason ? response.data.SocialReason : ''
            that.dateCreation = that.databaseDateCreation = response.data.DateCreation ? response.data.DateCreation : ''
            that.address = that.databaseAddress = address
            that.zipCode = that.databaseZipCode = response.data.CodePostal ? response.data.CodePostal : ''
            that.townName = that.databaseTownName = response.data.City ? response.data.City : ''
            that.coreBusinessLabel = that.databaseCoreBusinessLabel = response.data.CoreBusinessLabel ? response.data.CoreBusinessLabel : ''
            that.coreBusinessCode = that.databaseCoreBusinessCode = response.data.CoreBusinessCode ? response.data.CoreBusinessCode : ''
            that.isCoreBusinessAllowed = response.data.CoreBusinessAllowed ? response.data.CoreBusinessAllowed : '1'
            that.coreBusiness = that.coreBusinessCode + ' - ' + that.coreBusinessLabel
            /* pour une démo - à enlever plus tard */
            if (that.siren === '823971775') {
              that.name = 'BARRE'
              that.firstname = 'Bénédicte'
            }
            that.$f7.hidePreloader()
          }
        })
        .catch(error => {
          if (error.response != null && error.response.data.errors != null && error.response.data.errors[0].errorDescription === 'Siren key parameter is invalid') {
            that.sirenRegexpError = true
          }
          errorMessageAlert(error, that)
        })
      }
    }
  },
  computed: {
    /** @author TLV 15/02/2021
    * @brief Si l'utilisateur change un des champs et que celui qu'il a
    *       sélectionné est différent de celui trouvé en bdd, un warning est affiché à l'écran
    */
    databaseLegalStatuslabel () {
      if (this.databaseLegalStatus !== '') {
        var foundLabel = ''
        this.legalStatusList.map(legalStatus => {
          if (this.databaseLegalStatus === legalStatus.code) {
            foundLabel = legalStatus.label
          }
        })
        return foundLabel
      }
    },
    differentFirstName () {
      return this.databaseFirstName !== '' && this.firstname !== this.databaseFirstName
    },
    differentLastName () {
      return this.databaseLastName !== '' && this.name !== this.databaseLastName
    },
    differentLegalStatus () {
      return this.databaseLegalStatus !== '' && this.legalStatus !== this.databaseLegalStatus
    },
    differentSIRET () {
      return this.databaseSIRET !== '' && this.siret !== this.databaseSIRET
    },
    differentSocialReason () {
      return this.databaseSocialReason !== '' && this.socialReason !== this.databaseSocialReason
    },
    invalidCoreBusiness () {
      return ((this.databaseCoreBusinessLabel !== '' && this.databaseCoreBusinessCode !== '') &&
              (this.coreBusiness !== this.databaseCoreBusinessCode + ' - ' + this.databaseCoreBusinessLabel)) ||
              this.isCoreBusinessAllowed !== '1'
    }
  },
  methods: {
    createSupplier () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('loading.adding_supplier'))
      let that = this

      that.$engine.services.suppliers.create({
        SellerIdentifier: this.sellerIdentifier,
        SocialReason: this.socialReason,
        Name: this.name,
        LegalRepresentativeLastName: this.name,
        LegalRepresentativeFirstName: this.firstname,
        LegalForm: this.legalStatus,
        Siren: this.siren,
        Siret: this.siret,
        Email: this.emailAddress,
        StreetName: this.address,
        PostalCode: this.zipCode,
        TownName: this.townName,
        ControlsMode: this.controlsConfig,
        CreateAccount: this.createAccount
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200 || response.status === 201) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.supplier_added'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    validateForm () {
      let flagsList = {}
      if (!this.LMSGsupplierconfig) {
        /* To generate an alpha-numeric string, you can pass an integer value between
        * 2 and 36 to the toString() method called radix. It defines the base to
        *  use for representing a numeric value :
        * https://attacomsian.com/blog/javascript-generate-random-string */
        this.sellerIdentifier = Math.random().toString(16).substr(2, 10)
      }
      if (this.isCoreBusinessAllowed === '0') {
        return false
      }
      let mandatoryValues = ['siren', 'siret', 'socialReason', 'sellerIdentifier']
      let regexpValues = {
        'siren': 'SIREN',
        'siret': 'SIRET',
        'emailAddress': 'email'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    }
  }
}
</script>



// WEBPACK FOOTER //
// SupplierCreateTemplate.vue?d2c113b4